<template>
  <div v-if="budgetLoaded">
    <div class="Fuell-Toolbar justify-content-between">
      <div class="d-flex toolbar-column">
        <entity-search-input @search="fetchTransactions" />
        <div class="d-flex flex-row">
          <button
            @click="showFilterModal"
            class="Fuell-ToolbarButton"
          >
            <span class="Fuell-ToolbarButton--icon">
              <img
                :src="require('@/assets/img/icons/icon-filter.svg')"
                alt="filter"
              />
            </span>
            <span class="Fuell-ToolbarButton--label">
              {{ $t('FILTERS') }}
            </span>
            <span
              class="Fuell-ToolbarButton--badge"
              v-if="filtersAmount"
              aria-hidden="true"
            >
              {{ filtersAmount }}
            </span>
          </button>
          <span
            class="Fuell-ToolbarButton remove-container"
            v-if="filtersAmount > 0"
            @click.prevent.stop="resetFilters"
          >
            <img
              style="height:10px;"
              :src="require('@/assets/img/icons/close-menu.svg')"
              alt="remove-filters"
            />
          </span>
        </div>
      </div>
    </div>

    <transactions-table
      :tableName="tableName"
      :columns="columns"
      :actionsList="actionsList"
      showSelect
      @budgetUpdated="handleBudgetUpdate"
      @showReceiptModal="showReceiptModal"
      @showDetailTransactionModal="showTransactionModal"
      @showTransactionModal="showTransactionModal"
      @showMileageModal="showCreateMileageModal"
      @showDietModal="showDietModal"
      @showExpenseModal="showCreateExpenseModal"
    />
    <transaction-receipts-viewer-modal
      :open.sync="showTransactionReceiptModalFlag"
      :preloadReceiptId="preloadReceiptId"
      :transactionId.sync="transactionToShowReceiptId"
      v-if="showTransactionReceiptModalFlag"
    ></transaction-receipts-viewer-modal>
    <create-expense-modal
      v-if="showCreateExpenseModalFlag"
      :transactionId.sync="transactionToEditId"
      :open.sync="showCreateExpenseModalFlag"
      @expenseCreated="fetchTransactions"
      @showReceiptModal="showReceiptModal"
      @confirmDelete="showConfirmDeleteTransactionModal"
      @closeModal="handleCloseTransactionReceiptModal"
      @reviewStatusChanged="getCurrentBudget"
      @showTransactionModal="showTransactionModal"
    ></create-expense-modal>

    <create-mileage-modal
      v-if="showCreateMileageModalFlag"
      :open.sync="showCreateMileageModalFlag"
      :transactionId.sync="transactionToEditId"
      @showReceiptModal="showReceiptModal"
      @confirmDelete="showConfirmDeleteTransactionModal"
      @expenseCreated="fetchTransactions"
      @closeModal="handleCloseTransactionReceiptModal"
      @reviewStatusChanged="getCurrentBudget"
      @showTransactionModal="showTransactionModal"
    ></create-mileage-modal>
    <create-diet-modal
      v-if="showCreateDietModalFlag"
      :open.sync="showCreateDietModalFlag"
      :transactionId.sync="transactionToEditId"
      @expenseCreated="fetchTransactions"
      @showReceiptModal="showReceiptModal"
      @confirmDelete="showConfirmDeleteTransactionModal"
      @closeModal="handleCloseTransactionReceiptModal"
      @reviewStatusChanged="getCurrentBudget"
      @showTransactionModal="showTransactionModal"
    />
    <transactions-filter-modal
      v-if="showFilterModalFlag"
      :open.sync="showFilterModalFlag"
      hideBudget
      isBudget
      @resetTransactionsFilters="fetchTransactions($event)"
      @reviewStatusFilterSelected="incrementReviewStatusFilterCounter"
    >
    </transactions-filter-modal>
    <confirm-modal
      @dismiss="showConfirmDeleteTransactionModalFlag = false"
      @accept="deleteTransaction"
      v-if="showConfirmDeleteTransactionModalFlag"
      :title="'ACTION_REMOVE'"
      :acceptText="'ACTION_REMOVE'"
    ></confirm-modal>
  </div>
  <div
    class="d-flex justify-content-center align-items-center"
    v-else
  >
    <spinner />
  </div>
</template>

<script>
import _expenseModalHandlerMixin from '@/modules/transactions/_mixins/_expenseModalHandlerMixin'
import _transactionsIndexViewShared from '../../../transactions/_mixins/_transactionsIndexViewShared'
import _revissionFunnelActions from '@/modules/transactions/_mixins/funnel/_revissionFunnelActionsMixin'
import { BULK_FUNNEL_ACTIONS, REVIEW_STATUS } from '@/constants/reviewStatus'
import TransactionsTable from '@/modules/transactions/_components/_shared/TransactionsTable'
import EntitySearchInput from '@/components/Commons/Search/EntitySearchInput'
import Spinner from '@/components/Commons/Spinner'

const CreateExpenseModal = () => import('@/modules/transactions/_components/expenses/CreateExpenseModal')
const CreateMileageModal = () => import('@/modules/transactions/_components/expenses/CreateMileageModal')
const CreateDietModal = () => import('@/modules/transactions/_components/expenses/CreateDietModal')
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')
const TransactionReceiptsViewerModal = () => import('@/modules/transactions/_components/_shared/TransactionReceiptsViewerModal')
export default {
  name: 'BudgetReimbursementsIndex',
  components: {
    TransactionsTable,
    CreateExpenseModal,
    CreateMileageModal,
    CreateDietModal,
    ConfirmModal,
    TransactionReceiptsViewerModal,
    EntitySearchInput,
    Spinner
  },
  mixins: [
    _expenseModalHandlerMixin,
    _revissionFunnelActions,
    _transactionsIndexViewShared
  ],
  data () {
    return {
      tableName: 'budgetReimbursements',
      hideBudget: true,
      actionsList: [
        BULK_FUNNEL_ACTIONS.APPROVE,
        BULK_FUNNEL_ACTIONS.REJECT,
        BULK_FUNNEL_ACTIONS.LOCK,
        BULK_FUNNEL_ACTIONS.UNLOCK,
        BULK_FUNNEL_ACTIONS.ACCOUNT
      ],
      budgetLoaded: false
    }
  },
  computed: {
    budgetId () {
      return this.$route.params.id || false
    },
    columns () {
      return this.$store.getters['TransactionsStore/tableColumns'].filter(item => item.table ? item.table.includes(this.tableName) : item)
    }
  },
  methods: {
    async fetchTransactions (event) {
      let force = false
      const filters = {
        'budget.id': this.budgetId,
        'type.code': 'EXPENSE',
        'reviewStatus.code': [REVIEW_STATUS.AWAITING_REVIEW, REVIEW_STATUS.CANCELLED, REVIEW_STATUS.APPROVED, REVIEW_STATUS.OFFICE_FLOW_REVISION]
      }
      if (event && event.length >= 3) {
        filters.query = event
      }
      if (event && event.force) {
        force = true
      }
      await this.$store.dispatch('TransactionsStore/setTransactionsFilters', { filters: filters, force: force, budget: true })
      this.$store.dispatch('TransactionsStore/setUserSelectedFiltersAmount', this._countFilters(filters))
    },
    async fetchUserBudgets () {
      const userBudgetsFilters = {
        'budget.status.code': 'ACTIVE',
        'isMember': true
      }
      await this.$store.dispatch('UsersStore/fetchUserBudgets', {
        pagination: false,
        filters: userBudgetsFilters
      })
    }
  },
  async created () {
    await this.$store.dispatch('BudgetsStore/fetchBudget', this.budgetId)
    this.budgetLoaded = true
    this.$emit('budgetLoaded', this.budgetLoaded)
    await this.fetchTransactions()
    await this.fetchUserBudgets()
  }

}
</script>
